// 评估说明配置（培哥补充0502）
// 支持多条，仅一条可设为当前生效

export const evaluationInstructions = [
  {
    instruction_id: 1,
    content: '请根据您对该员工的日常观察，客观勾选以下行为指标：\n\n1. 勾选"是"表示观察到该行为，系统将自动累加对应分值\n2. 勾选"否"表示未观察到该行为，不得分\n3. 勾选"不了解"表示无法判断，不影响得分\n\n评分规则：\n- 0-4分：低风险，员工稳定性良好\n- 5-10分：中风险，存在离职倾向，需要关注\n- ≥11分：高风险，离职风险极高，需立即干预',
    status: 1,
    is_active: 1,
    updated_at: '2026-05-02 10:00:00'
  }
]

export function getStoreInstructions() {
  const s = require('../store').default
  return s.state.evaluationInstructions && s.state.evaluationInstructions.instructions && s.state.evaluationInstructions.instructions.length
    ? s.state.evaluationInstructions.instructions
    : evaluationInstructions
}

export function getActiveInstruction() {
  const list = getStoreInstructions()
  return list.find(i => i.is_active === 1 && i.status === 1) || list[0] || null
}
